const content = {
    nav: {
        logo: 'Ali Chaabane',
        links: [
            // { text: 'Work', to: 'project' },
            { text: 'Contact', to: 'contact' },
        ],
    },

    header: {
        text: ['Hi!', "I'm Ali Chaabane.", 'I am a '],
        typical: [
            'Full Stack Developer 💻',
            2000,
            'Mobile & Web Developer 📱',
            2000,
        ],
        btnText: 'Discover More',
    },


    stack: {
        title: 'Technologies I Use',
        tech: [
            {
                img: process.env.PUBLIC_URL + '/assets/flutter.png',
                alt: 'Flutter',
            },
            {
                img: process.env.PUBLIC_URL + '/assets/ionic.png',
                alt: 'Ionic',
            },
            {
                img: process.env.PUBLIC_URL + '/assets/angular.png',
                alt: 'Angular',
            },
           {
                img: process.env.PUBLIC_URL + '/assets/spring.png',
                alt: 'Spring Boot',
            },
            {
                img: process.env.PUBLIC_URL + '/assets/vue.png',
                alt: 'Vue.js',
            },
            {
                img: process.env.PUBLIC_URL + '/assets/nuxt.png',
                alt: 'nuxt.js',
            },
            {
                img: process.env.PUBLIC_URL + '/assets/node.png',
                alt: 'Node.js',
            },
            {
                img: process.env.PUBLIC_URL + '/assets/express.png',
                alt: 'Express.js',
            },
        ],
        desc: `
    I specialize in cross-platform mobile and web development.

    For mobile applications, I primarily use Flutter and Ionic to build high-quality,
    performant applications for both Android and iOS, including Progressive Web Apps (PWA).

    On the web and backend side, I work mainly with Angular and Node.js (Express),
    as well as Java Spring Boot for building scalable and maintainable backend services.

    I focus on clean architecture, performance, and real-world production-ready solutions,
    and I continuously improve my skills by exploring modern tools and frameworks.
    `,
    },

    languages: {
  title: 'Languages',
  list: [
    {
      name: 'Arabic',
      level: 'Native',
      percent: 100,
    },
    {
      name: 'English',
      level: 'Advanced',
      percent: 90,
    },
    {
      name: 'French',
      level: 'Advanced',
      percent: 80,
    },
    {
      name: 'Italian',
      level: 'Practical use at work',
      percent: 30,
    },
    {
      name: 'Turkish',
      level: 'Intermediate',
      percent: 40,
    },
  ],
},


    project: {
        visible: false,
        title: 'Projects',
        img: process.env.PUBLIC_URL + '/assets/project-mobile.png',
        imgPlaceholder:
            'data:image/png;base64,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',
        projectName: 'Meetup',
        desc: 'Getting Started with Meetup App (my first react project) ',
        website: 'https://meetups-project-86e41.web.app/'
    },

contact: {
  title: 'Get in Touch',
  desc: `
Full Stack Developer with over 5 years of experience in web and cross-platform
mobile application development.

I have strong hands-on experience with Flutter, Ionic, Angular, Node.js, and Java Spring Boot,
and I have worked on production-level enterprise and e-commerce applications
for international clients.

I focus on building scalable, clean, and maintainable software solutions,
and I adapt quickly to Agile environments while collaborating effectively within teams.
`,
  socials: [
    {
      alt: 'whatsapp',
      img: process.env.PUBLIC_URL + '/assets/whatsapp.png',
      link: 'https://api.whatsapp.com/send/?phone=905421959236&text&type=phone_number&app_absent=0',
    },
    {
      alt: 'email',
      img: process.env.PUBLIC_URL + '/assets/gmail.png',
      link: 'mailto:alichaabane.work@gmail.com',
    },
    {
      alt: 'linkedin',
      img: process.env.PUBLIC_URL + '/assets/link.png',
      link: 'https://www.linkedin.com/in/ali-chaabane/',
    },
    {
      alt: 'github',
      img: process.env.PUBLIC_URL + '/assets/github.png',
      link: 'https://github.com/alichaabane',
    },

  ],
    img: process.env.PUBLIC_URL + '/assets/my-image.jpg',

},
};
export default content;
